import React, {useEffect, useState, useRef} from 'react';
import {Button, Modal, ModalBody} from 'reactstrap';

import '../i18/config';
import {useTranslation} from "react-i18next";
import CodeConfirmation from "./CodeConfirmation";

interface ModalTwoStepProps {
    isShow : boolean,
    handleShow: ()=>void,
    onChange: (code:string) => void
}

const ModalTwoStep = ({isShow, handleShow, onChange}:ModalTwoStepProps) => {

    const { t } = useTranslation(['common']);

    return (
        <Modal
            isOpen={isShow}
            toggle={() => {
                handleShow();
            }}
            backdrop={'static'}
            id="staticBackdrop"
            centered
            autoFocus={false}
        >
            <ModalBody className="p-5">

                    <h3 className="mb-3 text-center">{t('connector:enterCode')}</h3>

                <div className="d-flex flex-column">
                    <CodeConfirmation
                        handleCancel={handleShow}
                        onChange={onChange}
                    />
                    <div
                        className="m-0 alert alert-success alert-border-left fade show"
                        role="alert">

                        <i className="ri-error-warning-line me-2 align-middle"/> <strong
                        className="pe-2">{t('common:attention')}!</strong>

                        {t('connector:serviceConnectionGPDRDescription')}
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default ModalTwoStep;